import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";

const navItems = [
  { label: "首页", to: "/" },
  { label: "剧情伦理", to: "/category/drama" },
  { label: "爱情伦理", to: "/category/romance" },
  { label: "社会伦理", to: "/category/society" },
  { label: "全部片库", to: "/category/all" },
  { label: "关于", to: "/about" },
  { label: "联系", to: "/contact" },
];

export default function SiteHeader() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [menuOpen]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled || menuOpen
          ? "bg-background-50/95 backdrop-blur-md border-b border-background-200/70"
          : "bg-gradient-to-b from-background-50/90 via-background-50/40 to-transparent border-b border-transparent"
      }`}
    >
      <div className="px-4 md:px-8 lg:px-12">
        <div className="flex items-center justify-between h-16 md:h-20">
          <Link to="/" className="flex items-center gap-3 group cursor-pointer">
            <span className="w-9 h-9 md:w-10 md:h-10 rounded-md bg-primary-500 text-background-50 flex items-center justify-center">
              <i className="ri-film-line text-xl md:text-2xl" aria-hidden="true"></i>
            </span>
            <span className="flex flex-col leading-none">
              <span className="font-heading font-semibold text-foreground-950 text-[13px] sm:text-sm md:text-base tracking-wide whitespace-nowrap">
                韩国伦理电影在线观看
              </span>
              <span className="hidden sm:block font-label text-[10px] md:text-[11px] tracking-[0.32em] text-primary-500 mt-1">
                KOREAN CINEMA ARCHIVE
              </span>
            </span>
          </Link>

          <nav className="hidden lg:flex items-center gap-7" aria-label="主导航">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/"}
                className={({ isActive }) =>
                  `relative text-sm transition-colors duration-200 py-2 whitespace-nowrap cursor-pointer ${
                    isActive
                      ? "text-primary-500 font-medium"
                      : "text-foreground-700 hover:text-foreground-950"
                  }`
                }
              >
                {({ isActive }) => (
                  <>
                    {item.label}
                    <span
                      className={`absolute left-0 right-0 -bottom-0.5 h-[2px] bg-primary-500 transition-transform duration-300 origin-left ${
                        isActive ? "scale-x-100" : "scale-x-0"
                      }`}
                    ></span>
                  </>
                )}
              </NavLink>
            ))}
          </nav>

          <div className="flex items-center gap-2 md:gap-3">
            <Link
              to="/search"
              className="flex items-center gap-2 h-9 px-3 md:px-4 rounded-md border border-background-300/70 text-foreground-700 hover:text-foreground-950 hover:border-primary-400 transition-colors cursor-pointer"
              aria-label="搜索影片"
            >
              <i className="ri-search-line text-base" aria-hidden="true"></i>
              <span className="hidden md:inline text-sm">搜索影片</span>
            </Link>
            <button
              type="button"
              onClick={() => setMenuOpen((open) => !open)}
              className="lg:hidden w-9 h-9 rounded-md border border-background-300/70 flex items-center justify-center text-foreground-800 cursor-pointer"
              aria-label={menuOpen ? "关闭菜单" : "打开菜单"}
              aria-expanded={menuOpen}
            >
              <i className={menuOpen ? "ri-close-line text-xl" : "ri-menu-line text-xl"} aria-hidden="true"></i>
            </button>
          </div>
        </div>
      </div>

      <div
        className={`lg:hidden overflow-hidden border-t border-background-200/60 bg-background-50 transition-[max-height,opacity] duration-300 ${
          menuOpen ? "max-h-[560px] opacity-100" : "max-h-0 opacity-0"
        }`}
      >
        <nav className="px-4 py-4 flex flex-col" aria-label="移动端导航">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === "/"}
              className={({ isActive }) =>
                `flex items-center justify-between py-3 border-b border-background-200/60 text-sm cursor-pointer ${
                  isActive ? "text-primary-500" : "text-foreground-700"
                }`
              }
            >
              <span>{item.label}</span>
              <i className="ri-arrow-right-s-line text-lg text-foreground-500" aria-hidden="true"></i>
            </NavLink>
          ))}
          <Link
            to="/search"
            className="mt-4 h-11 rounded-md bg-primary-500 text-background-50 text-sm font-medium flex items-center justify-center gap-2 cursor-pointer"
          >
            <i className="ri-search-line" aria-hidden="true"></i>
            搜索影片
          </Link>
        </nav>
      </div>
    </header>
  );
}